import { Component } from '@angular/core';
import { NavController, Events } from 'ionic-angular';

// Pages
import { ReportCertificationStatusDateRangePage } from './report.certifications-date-range';
import { ReportEmailListPage } from './report.email-list';
import { ReportInstructorsEmployerPage } from './report.instructors-employer';
import { ReportInstructorsLocationPage } from './report.instructors-location'; 
import { ReportActiveProviderPage } from './report.active-provider';
import { ReportUncertifiedCandidatePage } from './report.uncertified-candidate';

@Component({
  selector: 'page-reports',
  templateUrl: 'reports.html'
})
export class ReportsPage {
  headerData: any;
  constructor(
    public navCtrl: NavController,
    public events: Events
  ) {
    this.headerData = { title: 'Reports & Lists' };
  }

  showCertsByDatePage()
  {
    this.navCtrl.push( ReportCertificationStatusDateRangePage );
  }

  showInstructorLocationPage()
  {
    this.navCtrl.push( ReportInstructorsLocationPage );
  }

  showInstructorEmployerPage()
  {
    this.navCtrl.push( ReportInstructorsEmployerPage );
  }

  showEmailExportPage()
  {
    this.navCtrl.push( ReportEmailListPage );
  }

  showActiveProviderPage()
  {
    this.navCtrl.push( ReportActiveProviderPage );
  }

  showUncertifiedInstructorCandidatePage()
  {
    this.navCtrl.push( ReportUncertifiedCandidatePage );
  }
}



// WEBPACK FOOTER //
// ./src/pages/reports/reports.ts